import { useDispatch, useSelector } from "react-redux";
import { weightDifferencesActions } from "../../_store/weightDifferences.slice";
import { WeightDifferencesForm } from "../../_components/Wastes/WeightDifferencesForm";

export function CreateWeightDifference() {
  const dispatch = useDispatch();
  const { weightDifferences: { paging } } = useSelector((x) => x.weightDifferences);

  async function onSubmit(payload) {
    const response = await dispatch(weightDifferencesActions.create(payload));
    if (!response?.error) {
      const pageNumber = paging?.pageNumber ?? 1;
      dispatch(weightDifferencesActions.getAll({ pageNumber }));
    }
    return response;
  }

  return <WeightDifferencesForm onSubmit={onSubmit} />;
}
